import "./style/style.css";

export function Nav() {
  const ScrollToSection = (id: string) => {
    const target = document.getElementById(id);
    if (target) {
      const targetPosition =
        target.getBoundingClientRect().top + window.scrollY - 60;

      window.scrollTo({
        top: id === "home" ? 0 : targetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <header className="nav_container">
      <nav className="nav_desktop">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            ScrollToSection("home");
          }}
        >
          Home
        </a>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            ScrollToSection("howtoplay");
          }}
        >
          How to play
        </a>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            ScrollToSection("contact");
          }}
        >
          Contact
        </a>
      </nav>
    </header>
  );
}
